import Link from "next/link";

import { SUBCATEGORY_LINK_NAMES } from "@/constants/products";

import IconSvg from "@/components/IconSvg";

interface Props {
  category: string;
  subcategory: string;
}

const ProductSubcategoryLinks: React.FC<Props> = ({
  category,
  subcategory,
}) => {
  const subcategoryLabel = SUBCATEGORY_LINK_NAMES[subcategory] || subcategory;

  return (
    <div className="flex flex-col gap-y-md md:grid md:grid-cols-3 md:flex-row md:gap-x-md md:gap-y-0 text-center font-bold mb-section">
      <Link
        href={{
          pathname: `/products/${category}/${subcategory}`,
          query: {
            "filter[deal_active]": "true",
            subcategoryPageTab: "shop",
          },
        }}
        className="shadow-low rounded grow p-lg"
      >
        <IconSvg
          svgClassName="inline fill-none"
          width="32"
          height="32"
          filePath="deal_blob.svg"
        />
        <br />
        {subcategoryLabel} deals near you
      </Link>
      <Link
        href={{
          pathname: `/products/${category}/${subcategory}`,
          query: {
            "shippable[]": "Ships to me",
            subcategoryPageTab: "catalog",
          },
        }}
        className="shadow-low rounded grow p-lg"
      >
        <IconSvg
          svgClassName="inline fill-none"
          width="32"
          height="32"
          filePath="truck_blob.svg"
        />
        <br />
        {subcategoryLabel} shipped to your door
      </Link>
      <Link
        href={{
          pathname: `/products/${category}/${subcategory}`,
          query: {
            "filter[thc]": "20.0-*",
            subcategoryPageTab: "shop",
          },
        }}
        className="shadow-low rounded grow p-lg"
      >
        <IconSvg
          svgClassName="inline fill-none"
          width="32"
          height="32"
          filePath="star_blob.svg"
        />
        <br />
        high thc {subcategoryLabel}
      </Link>
    </div>
  );
};

export default ProductSubcategoryLinks;
